import OpalPlanningLayout from "./components/OpalPlanningLayout/OpalPlanningLayout";
import OpalCoverageLayout from "./components/OpalCoverageLayout/OpalCoverageLayout";
import OpalDashboardLayout from "./components/OpalDashboardLayout/OpalDashboardLayout";
import OpalPlanningCenter from "./components/OpalPlanningCenter/OpalPlanningCenter";
import OpalOrderLayout from "./components/OpalOrderLayout/OpalOrderLayout";

const AppRoutes = [
  {
    path: 'coverage',
    element: <OpalCoverageLayout />
  },
  {
    path: 'coverage/:id',
    element: <OpalCoverageLayout />
  },
  {
    path: '/planning/:id',
    element: <OpalPlanningLayout />
  },
  {
    path: '/planning',
    element: <OpalPlanningCenter />
  },
  {
    path: '/dashboard',
    element: <OpalDashboardLayout />
  },
  {
    path: '/order',
    element: <OpalOrderLayout />
  }
];

export default AppRoutes;
